import { Asset } from '../types/comparables.interfaces';

/**
 * Function to determine which price to use based on the source_id or forced correction
 * If source_id is 87 or forceUseCorrectedPrice is true, use the variables with correction (_with_correction)
 * @param comparable - Asset object that contains source_id and price values
 * @param isMainPrice - If true returns price, if false returns price per square meter
 * @param forceUseCorrectedPrice - If true, forces the use of corrected prices regardless of source_id
 * @returns The correct price value based on source_id or forced correction
 */
export const getCorrectPrice = (comparable: Asset, isMainPrice: boolean = true, forceUseCorrectedPrice: boolean = false): number => {
  const useCorrectedPrice = forceUseCorrectedPrice || comparable.source_id === 87;
  
  if (isMainPrice) {
    return useCorrectedPrice ? (comparable.last_price_with_correction || comparable.last_price) : comparable.last_price;
  }
  
  return useCorrectedPrice ? (comparable.last_price_pm2_with_correction || comparable.last_pm2) : comparable.last_pm2;
};
